(function () {
  const nav = document.querySelector('minimal-nav');
  if (!nav) return;

  const toggle = nav.querySelector('[data-minimal-nav-toggle]');
  const close = nav.querySelector('[data-minimal-nav-close]');
  const drawer = nav.querySelector('[data-minimal-nav-drawer]');
  const overlay = nav.querySelector('[data-minimal-nav-overlay]');

  function openDrawer() {
    drawer?.classList.add('is-open');
    overlay?.removeAttribute('hidden');
    overlay?.classList.add('is-visible');
    drawer?.setAttribute('aria-hidden', 'false');
    toggle?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer?.classList.remove('is-open');
    overlay?.classList.remove('is-visible');
    drawer?.setAttribute('aria-hidden', 'true');
    toggle?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    window.setTimeout(() => {
      if (!drawer?.classList.contains('is-open')) {
        overlay?.setAttribute('hidden', '');
      }
    }, 250);
  }

  toggle?.addEventListener('click', openDrawer);
  close?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);

  drawer?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeDrawer);
  });
})();
